import { useMemo, useState } from 'react';
import { styled } from '@mui/material/styles';
import { ModalBase } from '@components/Modal';
import { Select } from '@components/Select';
import { Typography } from '@components/Typography';
import { useTranslation } from '@hooks';

const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        outline: 'none',
        maxWidth: 480,
        width: 'calc(100% - 32px)',
    },
    '& .modal-base-content': {
        padding: 16,
    },
});

// Shown when a location is being linked to a social integration (TikTok/X) and the account has more
// than one connected account of that type — so the user picks exactly which identity to publish to,
// instead of the backend binding an arbitrary one.
const SocialAccountPickerModal = ({ open, onClose, integrations, title, onConnect, connecting }) => {
    const { t } = useTranslation();
    const [selectedId, setSelectedId] = useState(integrations[0]?.id || '');

    const options = useMemo(
        () =>
            (integrations || []).map(i => ({
                value: i.id,
                label: i.accountLabel || i.userIdentifier || i.id,
            })),
        [integrations],
    );

    return (
        <Modal
            isOpen={open}
            handleClose={onClose}
            title={title}
            onPrimaryAction={() => onConnect(selectedId)}
            primaryActionText={t('buttons.connect')}
            primaryActionDisabled={connecting || !selectedId}
        >
            <Typography variant="body2" color="textSecondary" sx={{ marginBottom: '16px' }}>
                {t('SettingsCompanies.selectAccountToLink')}
            </Typography>
            <Select
                label={t('SettingsCompanies.account')}
                value={selectedId}
                onChange={e => setSelectedId(e.target.value)}
                options={options}
                disabled={connecting}
            />
        </Modal>
    );
};

export default SocialAccountPickerModal;
